/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectDispatchPlan from 'modules/me/select-dispatch-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import { hasScheduledChanges } from 'state/current-dispatch/selectors';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';
import ScheduledChangesNotice from 'modules/me/dispatch/scheduled-changes-notice';

const EditPlan = (props) => {
    return (
        <Box>
            <DocumentHead title='Manage Dispatch Plan Billing - Tower Systems' />
            <Topbar title='Dispatch Plan' subTitle='Manage your Dispatch subscription' selected='dispatch'>
                <Button primary link='/dashboard/dispatch'>
                    View Subscription Details
                </Button>
            </Topbar>
            {props.hasScheduledChanges && (
                <Box marginBottom='xxlarge'>
                    <ScheduledChangesNotice></ScheduledChangesNotice>
                </Box>
            )}
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Dispatch plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a Dispatch plan below to view
                            the estimated plan price.
                        </Text>
                    </Box>
                    <Box>
                        <SelectDispatchPlan />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {},
)(EditPlan);
